module.exports = __webpack_public_path__ + "static/media/IMG_8037.633e7425.jpg";